import ArtBoard from "@/components/task/ArtBoard";
import BuildForCreators from "@/components/task/BuiltForCreators";
import CTA from "@/components/task/CTA";
import Difference from "@/components/task/Difference";
import ExploreRoles from "@/components/task/ExploreRoles";
import FeaturedCaseStudy from "@/components/task/FeaturedCaseStudy";
import Footer from "@/components/task/Footer";
import GameChanger from "@/components/task/GameChanger";
import TaskHeader from "@/components/task/Header";
import HowItWorks from "@/components/task/HowItWorks";
import OurClients from "@/components/task/OurClients";
import PayWithEnfiniPay from "@/components/task/PayWithEnfinipay";
import RevenueCalculator from "@/components/task/RevenueCalculator";
import { useEffect } from "react";

export default function Task() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="space-y-28 bg-[#121212]">
      <TaskHeader />

      <ExploreRoles />

      <FeaturedCaseStudy />

      <BuildForCreators />

      <RevenueCalculator />

      <GameChanger />

      <HowItWorks />

      <PayWithEnfiniPay />

      <Difference />

      <ArtBoard />

      <OurClients />

      <div className="min-h-[900px] bg-[#1a1a1a] lg:pb-36 xxs:pb-60">
        <CTA />
      </div>

      <Footer />
    </div>
  );
}
